import React, { Component } from 'react';
import FakeData from '.././fake-data';
import { Link } from 'react-router-dom';

import './InternalNoticeCenter.css';
import Positions from './Positions';
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';

import { AddNewPlayer, ItemPicker, Modal, ConfirmModal, EmptyState } from './Common';
import Redirect from 'react-router-dom/Redirect';

export default class InternalNoticeCenter extends Component {
    constructor(props){
        super(props)
        this.state = {
            isSettings : false
        }
    }

    goToSettings = (type, _profile) => {
        let profile = _profile;
        profile.type = type;
        window.location = FakeData.getPath(profile, "?sInit=settings").pathname+FakeData.getPath(profile, "?sInit=about").search;
    }

    render = () => {
        const {isSettings} = this.state;
        const _link = <Link to={{}}></Link>;
        const { notices, profile, type } = this.props;
        if (!profile.isAdmin) {
            profile.type = type;
            <Redirect to={{
                pathname: FakeData.getPath(profile),
                state: { from: {pathname:"/404"} }
            }} />
        }

        return (
            <div className="internal-notice-center" style={{ minHeight: "800px", width: "100%", background: "#fff",  }}>
                {!this.props.hideHeader &&
                    <div className="internal-notice-center-head">
                        <h1>Notifications</h1>
                        {!this.props.hideSettingBtn &&
                            <div className="internal-notice-center-head-actions">
                                <div onClick={()=>{
                                    this.goToSettings(type, profile);
                                }}>Settings</div>
                            </div>
                        }
                    </div>
                }
                <div className="internal-notice-center-body">
                    {
                        FakeData.listify(notices).map((item, i) => {
                            return (
                                <NotificationItem notice={item} key={"notice_" + item.id} />
                            )
                        })
                    }
                    <EmptyState isShown={(FakeData.listify(notices).length === 0) ? true : false} text="No notifictions were found!" icon="notifications_off" />
                </div>
            </div>
        );
    }
}

export class NotificationItem extends Component {
    state = {
        type: this.props.notice.actionData.context,
        isOpen: false
    }

    markRead = (bool) => {
        const { notice } = this.props
        const _that = this;
        const isBool = Boolean(bool)
        const data = { id: notice.id, value: 1 };
        if (isBool) {
            if (this.props.mountedCallBack) {
                this.props.mountedCallBack.call(this)
            }
            FakeData.post("/readNotice.php?auth0", data, {
                success(res) {

                },
                error(err) {

                }
            }, true, "", () => { })

            return;
        }

        FakeData.post("/readNotice.php?auth0", data, {
            success(res) {
                if (res.status) {
                    FakeData.alert("Done!");
                    _that.refs.more.blur()
                } else {
                    FakeData.alert("Couldn't perform action, please try again!");
                    _that.refs.more.blur()
                }
            },
            error(err) {
                FakeData.alert("Couldn't perform action, please try again!");
                _that.refs.more.blur()
            }
        }, true, "", () => { })
    }

    markUnread = () => {
        const { notice } = this.props
        const _that = this;
        const data = { id: notice.id, value: 0 };
        FakeData.post("/readNotice.php?auth0", data, {
            success(res) {
                if (res.status) {
                    FakeData.alert("Done!");
                    _that.refs.more.blur()
                } else {
                    FakeData.alert("Couldn't perform action, please try again!");
                    _that.refs.more.blur()
                }
            },
            error(err) {
                FakeData.alert("Couldn't perform action, please try again!");
                _that.refs.more.blur()
            }
        }, true, "", () => { })
    }

    blockType = () => {
        const { notice } = this.props
        this.refs.more.blur()
    }

    unblockType = () => {
        const { notice } = this.props
        this.refs.more.blur()
    }

    action = () => {
        alert("Works!")
    }

    negate = () => {
        alert("Negated")
    }

    getActions = (_type = '', item) => {
        let list = [];
        const notice = item;
        const _that = this
        const { commentId, replyId, type, id } = notice.actionData.contextTarget;
        const page_types = _type.split("^");
        let __type = page_types[0];
        switch (__type) {
            case "club_invite":
                list = [
                    {
                        action: () => {
                            const _that = this;
                            const data = {
                                id: notice.actionData.contextId,
                                user: notice.user,
                                userTo: notice.otherUser,
                                status: "accepted",
                                noticeId: notice.id
                            }

                            FakeData.post("/acceptClubInvite.php?auth0", data, {
                                success(r) {
                                    FakeData.alert("Done!");
                                    _that.setState({ isOpen: false })
                                },
                                error(r) {
                                    FakeData.alert("Couldn't reached server!");
                                    _that.setState({ isOpen: false })
                                }
                            }, true, "", () => { })
                        },
                        jsx: (props) => (<button className="positive" onClick={props.onClick}>Accept</button>)
                    },
                    {
                        action: () => {
                            const _that = this;
                            const data = {
                                id: notice.actionData.contextId,
                                user: notice.user,
                                userTo: notice.otherUser,
                                status: "declined",
                                noticeId: notice.id
                            }

                            FakeData.post("/acceptClubInvite.php?auth0", data, {
                                success(r) {
                                    FakeData.alert("Done!");
                                    _that.setState({ isOpen: false })
                                },
                                error(r) {
                                    FakeData.alert("Couldn't reached server!");
                                    _that.setState({ isOpen: false })
                                }
                            }, true, "", () => { })
                        },
                        jsx: (props) => (<button className="negative" onClick={props.onClick}>Decline</button>)
                    },
                    {
                        action: () => { },
                        link: () => (<Link to={{ pathname: '/' + ((notice.otherUser.type === "T") ? "team" : (notice.otherUser.type === "I") ? "institution" : "club") + '/' + ((notice.otherUser.type === "T") ? item.otherUser.id : item.otherUser.user), search: "?sInit=about" }}>View Profile</Link>)
                    }
                ]
                break;
            case "team_invite":
                list = [
                    {
                        action: (_player, callback) => {
                            const dataTo = {
                                player: _player,
                                data: {
                                    id: notice.actionData.contextId,
                                    user: notice.user,
                                    userTo: notice.otherUser,
                                    noticeId: notice.id,
                                    teamId: notice.actionData.contextTarget.id,
                                    squadId: notice.actionData.contextTarget.squadId,
                                    status: "accepted"
                                }
                            }

                            FakeData.post("/acceptTeamInvite.php?auth0", dataTo, {
                                success(r) {
                                    FakeData.alert("Done!");
                                    _that.setState({ isOpen: false })
                                },
                                error(r) {
                                    FakeData.alert("Couldn't reached server!");
                                    _that.setState({ isOpen: false })
                                }
                            }, true, "", () => { })
                        },
                        jsx: (props) => (<button className="positive" onClick={props.onClick}>Accept</button>)
                    },
                    {
                        action: () => {
                            const dataTo = {
                                player: { origin: "", position: "", number: "" },
                                data: {
                                    id: notice.actionData.contextId,
                                    user: notice.user,
                                    userTo: notice.otherUser,
                                    noticeId: notice.id,
                                    teamId: notice.actionData.contextTarget.id,
                                    squadId: notice.actionData.contextTarget.squadId,
                                    status: "declined"
                                }
                            }

                            FakeData.post("/acceptTeamInvite.php?auth0", dataTo, {
                                success(r) {
                                    FakeData.alert("Done!");
                                    _that.setState({ isOpen: false })
                                },
                                error(r) {
                                    FakeData.alert("Couldn't reached server!");
                                    _that.setState({ isOpen: false })
                                }
                            }, true, "", () => { })
                        },
                        jsx: (props) => (<button className="negative" onClick={props.onClick}>Decline</button>)
                    },
                    {
                        action: () => {

                        },
                        link: (props) => (<Link to={{ pathname: '/team/' + item.otherUser.id, search: "?sInit=about" }}>View Team</Link>)
                    }
                ]
                break;
            case "tourn_team_invite":
                list = [
                    {
                        action: () => {

                        },
                        jsx: (props) => (<button className="positive" onClick={props.onClick}>Accept</button>)
                    },
                    {
                        action: () => {

                        },
                        jsx: (props) => (<button className="negative" onClick={props.onClick}>Decline</button>)
                    },
                    {
                        action: () => { },
                        link: () => (<Link to={{ pathname: '/team/' + item.otherUser.id, search: "?sInit=about" }}>View Team</Link>)
                    }
                ]
                break;
            case "event_admin_invite":
                list = [
                    {
                        action: () => {
                            //acceptEventAdminRole
                            const dataTo = {
                                id: notice.actionData.contextId,
                                user: notice.user,
                                userTo: notice.otherUser,
                                status: "yes"
                            }

                            FakeData.post("/acceptEventAdminRole.php?auth0", dataTo, {
                                success(r) {
                                    FakeData.alert("Done!");
                                    _that.setState({ isOpen: false })
                                },
                                error(r) {
                                    FakeData.alert("Couldn't reached server!");
                                    _that.setState({ isOpen: false })
                                }
                            }, true, "", () => { })
                        },
                        jsx: (props) => (<button className="positive" onClick={props.onClick}>Accept</button>)
                    },
                    {
                        action: () => {
                            const dataTo = {
                                id: notice.actionData.contextId,
                                user: notice.user,
                                userTo: notice.otherUser,
                                status: "no"
                            }

                            FakeData.post("/acceptEventAdminRole.php?auth0", dataTo, {
                                success(r) {
                                    FakeData.alert("Done!");
                                    _that.setState({ isOpen: false })
                                },
                                error(r) {
                                    FakeData.alert("Couldn't reached server!");
                                    _that.setState({ isOpen: false })
                                }
                            }, true, "", () => { })
                        },
                        jsx: (props) => (<button className="negative" onClick={props.onClick}>Decline</button>)
                    },
                    {
                        action: () => { },
                        link: () => (<Link to={{ pathname: '/team/' + item.otherUser.id, search: "?sInit=about" }}>View Team</Link>)
                    }
                ]
                break;
            case "event_invite":
                list = [
                    {
                        action: () => {
                            const dataTo = {
                                id: notice.actionData.contextId,
                                user: notice.user,
                                userTo: notice.otherUser,
                                status: "yes"
                            }

                            FakeData.post("/acceptEventInvite.php?auth0", dataTo, {
                                success(r) {
                                    FakeData.alert("Done!");
                                    _that.setState({ isOpen: false })
                                },
                                error(r) {
                                    FakeData.alert("Couldn't reached server!");
                                    _that.setState({ isOpen: false })
                                }
                            }, true, "", () => { })
                        },
                        jsx: (props) => (<button className="positive" onClick={props.onClick}>Going</button>)
                    },
                    {
                        action: () => {
                            const dataTo = {
                                id: notice.actionData.contextId,
                                user: notice.user,
                                userTo: notice.otherUser,
                                status: "maybe"
                            }

                            FakeData.post("/acceptEventInvite.php?auth0", dataTo, {
                                success(r) {
                                    FakeData.alert("Done!");
                                    _that.setState({ isOpen: false })
                                },
                                error(r) {
                                    FakeData.alert("Couldn't reached server!");
                                    _that.setState({ isOpen: false })
                                }
                            }, true, "", () => { })
                        },
                        jsx: (props) => (<button className="energy" onClick={props.onClick}>Maybe</button>)
                    },
                    {
                        action: () => {
                            const dataTo = {
                                id: notice.actionData.contextId,
                                user: notice.user,
                                userTo: notice.otherUser,
                                status: "no"
                            }

                            FakeData.post("/acceptEventInvite.php?auth0", dataTo, {
                                success(r) {
                                    FakeData.alert("Done!");
                                    _that.setState({ isOpen: false })
                                },
                                error(r) {
                                    FakeData.alert("Couldn't reached server!");
                                    _that.setState({ isOpen: false })
                                }
                            }, true, "", () => { })
                        },
                        jsx: (props) => (<button className="negative" onClick={props.onClick}>Not going</button>)
                    }
                ]
                break;
            case "game_invite":
                list = [
                    {
                        action: () => {

                        },
                        jsx: (props) => (<button className="positive" onClick={props.onClick}>Accept</button>)
                    },
                    {
                        action: () => {

                        },
                        jsx: (props) => (<button className="negative" onClick={props.onClick}>Decline</button>)
                    },
                    {
                        action: () => { },
                        link: () => (<Link to={{ pathname: '/team/' + item.otherUser.id, search: "?sInit=about" }}>View Team</Link>)
                    }
                ]
                break;
            case "club_accept":
                list = [
                    {
                        action: () => {
                            this.setState({ isOpen: false })
                        },
                        jsx: (props) => (<button className="negative" onClick={props.onClick}>Close</button>)
                    },
                    {
                        action: () => { },
                        link: () => (<Link to={{ pathname: '/' + ((notice.otherUser.type === "T") ? "team" : (notice.otherUser.type === "I") ? "institution" : "club") + '/' + ((notice.otherUser.type === "T") ? item.otherUser.id : item.otherUser.user), search: "?sInit=about" }}>View Profile</Link>)
                    }
                ]
                break;
            case "team_accept":
                list = [
                    {
                        action: () => {
                            this.setState({ isOpen: false })
                        },
                        jsx: (props) => (<button className="negative" onClick={props.onClick}>Close</button>)
                    },
                    {
                        action: () => { },
                        link: () => (<Link to={{ pathname: '/profile/' + item.otherUser.user, search: "?sInit=about" }}>View Profile</Link>)
                    }
                ]
                break;
            case "tourn_team_accept":
                list = [
                    {
                        action: () => {
                            this.setState({ isOpen: false })
                        },
                        jsx: (props) => (<button className="negative" onClick={props.onClick}>Close</button>)
                    },
                    {
                        action: () => { },
                        link: () => (<Link to={{ pathname: '/team/' + item.otherUser.id, search: "?sInit=about" }}>View Team</Link>)
                    }
                ]
                break;
            case "event_accept":
                list = [
                    {
                        action: () => {
                            this.setState({ isOpen: false })
                        },
                        jsx: (props) => (<button className="negative" onClick={props.onClick}>Close</button>)
                    }
                ]
                break;
            case "game_accept":
                list = [
                    {
                        action: () => {
                            this.setState({ isOpen: false })
                        },
                        jsx: (props) => (<button className="negative" onClick={props.onClick}>Close</button>)
                    },
                    {
                        action: () => { },
                        link: () => (<Link to={{ pathname: '/team/' + item.otherUser.id, search: "?sInit=about" }}>View Team</Link>)
                    }
                ]
                break;
            case "group_forum_add":
                list = [
                    {
                        action: () => { },
                        link: () => (<Link to={{ pathname: '/group/' + notice.actionData.contextTarget.user, search: "?sInit=members" }}>View Group</Link>)
                    }
                ]
                break;
            case "group_forum_role":
                list = [
                    {
                        action: () => { },
                        link: () => (<Link to={{ pathname: '/group/' + notice.actionData.contextTarget.user, search: "?sInit=members" }}>View Group</Link>)
                    }
                ]
                break;
            case "group_forum_join":
                list = [
                    {
                        action: () => { },
                        link: () => (<Link to={{ pathname: '/group/' + notice.actionData.contextTarget.user, search: "?sInit=members" }}>View Group</Link>)
                    }
                ]
                break;
            case "group_add":
                list = [
                    {
                        action: () => {
                            this.setState({ isOpen: false })
                        },
                        jsx: (props) => (<button className="negative" onClick={props.onClick}>Close</button>)
                    }
                ]
                break;
            case "post_like":
                //const { commentId, replyId, type, id } = notice.actionData.contextTarget;
                list = [
                    {
                        action: () => { },
                        link: () => (<Link to={{ pathname: '/post/' + item.otherUser.user + '/posts/' + id + '/' + type, search: "?sComment=" + commentId + "&sReply=" + replyId }}>View Post</Link>)
                    },
                    {
                        action: () => {

                        },
                        jsx: (props) => (<button className="negative" onClick={props.onClick}>Turn Off</button>)
                    }
                ]
                break
            case "timeline_post":
                //const { commentId, replyId, type, id } = notice.actionData.contextTarget;
                list = [
                    {
                        action: () => { },
                        link: () => (<Link to={{ pathname: '/post/' + item.otherUser.user + '/posts/' + id + '/' + type, search: "?sComment=" + commentId + "&sReply=" + replyId }}>View Post</Link>)
                    },
                    {
                        action: () => {

                        },
                        jsx: (props) => (<button className="negative" onClick={props.onClick}>Turn Off</button>)
                    }
                ]
                break;
            case "timeline_event_post":
                list = [
                    {
                        action: () => { },
                        link: () => (<Link to={{ pathname: '/post/' + item.otherUser.user + '/posts/' + id + '/' + type, search: "?sComment=" + commentId + "&sReply=" + replyId }}>View Post</Link>)
                    },
                    {
                        action: () => {

                        },
                        jsx: (props) => (<button className="negative" onClick={props.onClick}>Turn Off</button>)
                    }
                ]
                break;
            case "timeline_group_post":
                //const { commentId, replyId, type, id } = notice.actionData.contextTarget;
                list = [
                    {
                        action: () => { },
                        link: () => (<Link to={{ pathname: '/post/' + item.otherUser.user + '/posts/' + id + '/' + type, search: "?sComment=" + commentId + "&sReply=" + replyId }}>View Post</Link>)
                    },
                    {
                        action: () => {

                        },
                        jsx: (props) => (<button className="negative" onClick={props.onClick}>Turn Off</button>)
                    }
                ]
                break;
            case "post_tag":
                //const { commentId, replyId, type, id } = notice.actionData.contextTarget;
                list = [
                    {
                        action: () => { },
                        link: () => (<Link to={{ pathname: '/post/' + item.otherUser.user + '/posts/' + id + '/' + type, search: "?sComment=" + commentId + "&sReply=" + replyId }}>View Post</Link>)
                    },
                    {
                        action: () => {

                        },
                        jsx: (props) => (<button className="negative" onClick={props.onClick}>Turn Off</button>)
                    }
                ]
                break;
            case "post_comment":
                //const { commentId, replyId, type, id } = notice.actionData.contextTarget;
                list = [
                    {
                        action: () => { },
                        link: () => (<Link to={{ pathname: '/post/' + item.otherUser.user + '/posts/' + id + '/' + type, search: "?sComment=" + commentId + "&sReply=" + replyId }}>View Post</Link>)
                    },
                    {
                        action: () => {

                        },
                        jsx: (props) => (<button className="negative" onClick={props.onClick}>Turn Off</button>)
                    }
                ]
                break;
            case "post_share":
                //const { commentId, replyId, type, id } = notice.actionData.contextTarget;
                list = [
                    {
                        action: () => { },
                        link: () => (<Link to={{ pathname: '/post/' + item.otherUser.user + '/posts/' + id + '/' + type, search: "?sComment=" + commentId + "&sReply=" + replyId }}>View Post</Link>)
                    },
                    {
                        action: () => {

                        },
                        jsx: (props) => (<button className="negative" onClick={props.onClick}>Turn Off</button>)
                    }
                ]
                break;
            case "post_tag":
                //const { commentId, replyId, type, id } = notice.actionData.contextTarget;
                list = [
                    {
                        action: () => { },
                        link: () => (<Link to={{ pathname: '/post/' + item.otherUser.user + '/posts/' + id + '/' + type, search: "?sComment=" + commentId + "&sReply=" + replyId }}>View Post</Link>)
                    },
                    {
                        action: () => {

                        },
                        jsx: (props) => (<button className="negative" onClick={props.onClick}>Turn Off</button>)
                    }
                ]
                break;
            case "comment_like":
                //const { commentId, replyId, type, id } = notice.actionData.contextTarget;
                list = [
                    {
                        action: () => { },
                        link: () => (<Link to={{ pathname: '/post/' + item.otherUser.user + '/posts/' + id + '/' + type, search: "?sComment=" + commentId + "&sReply=" + replyId }}>View Post</Link>)
                    },
                    {
                        action: () => {

                        },
                        jsx: (props) => (<button className="negative" onClick={props.onClick}>Turn Off</button>)
                    }
                ]
                break
            case "comment_reply":
                //const { commentId, replyId, type, id } = notice.actionData.contextTarget;
                list = [
                    {
                        action: () => { },
                        link: () => (<Link to={{ pathname: '/post/' + item.otherUser.user + '/posts/' + id + '/' + type, search: "?sComment=" + commentId + "&sReply=" + replyId }}>View Post</Link>)
                    },
                    {
                        action: () => {

                        },
                        jsx: (props) => (<button className="negative" onClick={props.onClick}>Turn Off</button>)
                    }
                ]
                break;
            case "reply_like":
                //const { commentId, replyId, type, id } = notice.actionData.contextTarget;
                list = [
                    {
                        action: () => { },
                        link: () => (<Link to={{ pathname: '/post/' + item.otherUser.user + '/posts/' + id + '/' + type, search: "?sComment=" + commentId + "&sReply=" + replyId }}>View Post</Link>)
                    },
                    {
                        action: () => {

                        },
                        jsx: (props) => (<button className="negative" onClick={props.onClick}>Turn Off</button>)
                    }
                ]
                break;
            case "relation_ship_accept":
                list = [
                    {
                        action: () => {
                            this.setState({ isOpen: false })
                        },
                        jsx: (props) => (<button className="negative" onClick={props.onClick}>Close</button>)
                    },
                    {
                        action: () => { },
                        link: () => (<Link to={{ pathname: '/profile/' + item.otherUser.user, search: "?sInit=about" }}>View</Link>)
                    }
                ]
                break;
            case "relation_ship_request":
                list = [
                    {
                        action: () => {
                            const _that = this;
                            const data = {
                                id: notice.actionData.contextId,
                                user: notice.user,
                                userTo: notice.otherUser,
                                status: "accepted",
                                noticeId: notice.id
                            }

                            FakeData.post("/acceptRelationship.php?auth0", data, {
                                success(r) {
                                    FakeData.alert("Done!");
                                    _that.setState({ isOpen: false })
                                    if (_that.props.unMountedCallBack) {
                                        _that.props.unMountedCallBack.call(this)
                                    }
                                },
                                error(r) {
                                    FakeData.alert("Couldn't reached server!");
                                    _that.setState({ isOpen: false })
                                    if (_that.props.unMountedCallBack) {
                                        _that.props.unMountedCallBack.call(this)
                                    }
                                }
                            }, true, "", () => { })
                        },
                        jsx: (props) => (<button className="positive" onClick={props.onClick}>Accept</button>)
                    },
                    {
                        action: () => {
                            const _that = this;
                            const data = {
                                id: notice.actionData.contextId,
                                user: notice.user,
                                userTo: notice.otherUser,
                                status: "declined",
                                noticeId: notice.id
                            }

                            FakeData.post("/acceptRelationship.php?auth0", data, {
                                success(r) {
                                    FakeData.alert("Done!");
                                    _that.setState({ isOpen: false })
                                    if (_that.props.unMountedCallBack) {
                                        _that.props.unMountedCallBack.call(this)
                                    }
                                },
                                error(r) {
                                    FakeData.alert("Couldn't reached server!");
                                    _that.setState({ isOpen: false })
                                    if (_that.props.unMountedCallBack) {
                                        _that.props.unMountedCallBack.call(this)
                                    }
                                }
                            }, true, "", () => { })
                        },
                        jsx: (props) => (<button className="negative" onClick={props.onClick}>Decline</button>)
                    },
                    {
                        action: () => { },
                        link: () => (<Link to={{ pathname: '/profile/' + item.otherUser.user, search: "?sInit=about" }}>View</Link>)
                    }
                ]
                break;
            default:
                list = [

                ]
                break;
        }
        return list;
    }

    render = () => {
        const { notice, style } = this.props;
        const { isOpen } = this.state
        return (
            <div className={(notice.context.status === "unread") ? "internal-notice-center-body-item active" : "internal-notice-center-body-item"} style={this.props.style}>
                <img src={notice.otherUser.image} onClick={() => this.setState({ isOpen: true })} />
                <div className="internal-notice-center-body-item-ctx">
                    <span onClick={() => this.setState({ isOpen: true })} dangerouslySetInnerHTML={{__html:notice.context.body}}></span>
                    <div className="internal-notice-center-body-item-ctx-time" onClick={() => this.setState({ isOpen: true })}>
                        {window.moment(notice.context.date).calendar()}
                    </div>
                    <div className="internal-notice-center-body-item-ctx-more" tabIndex={0} onFocus={() => {
                        if (this.props.mountedCallBack) {
                            this.props.mountedCallBack.call(this)
                        }
                    }} onBlur={() => {
                        if (this.props.unMountedCallBack) {
                            this.props.unMountedCallBack.call(this)
                        }
                    }} ref={"more"}>
                        <i className="material-icons">more_horiz</i>
                        <div className="internal-notice-center-body-item-ctx-more-act">
                            {(notice.context.status === "unread") &&
                                <span onClick={this.markRead.bind(this)}>Mark read</span>
                            }
                            {(notice.context.status !== "unread") &&
                                <span onClick={this.markUnread.bind(this)}>Mark unread</span>
                            }
                            {(!notice.actionData.isBlock) &&
                                <span onClick={this.blockType.bind(this)}>Block notice type</span>
                            }
                            {(notice.actionData.isBlock) &&
                                <span onClick={this.unblockType.bind(this)}>Unblock notice type</span>
                            }
                        </div>
                    </div>
                </div>
                {isOpen &&
                    <NotificationItemView onMoutedCallBack={this.markRead.bind(this)} item={notice} actions={this.getActions(notice.actionData.context, notice)} isOpen={isOpen} onClose={() => this.setState({ isOpen: false })} />
                }
            </div>
        );
    }
}

class NotificationItemView extends Component {
    state = {
        actions: this.props.actions,
        activeAction: null,
        isAddingPlayer: false
    }

    componentDidMount() {
        this.props.onMoutedCallBack(true);
    }

    acceptTeamInvite = (e, _item) => {
        if (e.target.className === "negative") {
            _item.action.call(this)
        } else {
            this.setState({ activeAction: _item, isAddingPlayer: true });
        }
    }

    onPlayerSave(player) {
        const { actions, isAddingPlayer, activeAction } = this.state
        activeAction.action(player, () => {
            this.setState({ activeAction: null, isAddingPlayer: false });
        })
    }

    render = () => {
        const { isOpen, item } = this.props
        const { actions, isAddingPlayer, activeAction } = this.state
        return (
            <Modal isOpen={isOpen} onClose={this.props.onClose}>
                <div className="add-place notice-pop-up" style={{ width: "500px" }}>
                    <div className="notice-pop-up-content">
                        <div className="notice-pop-up-content-head">
                            <img src={item.otherUser.image} />
                            <div className="notice-pop-up-content-head-tail" />
                        </div>
                        <div className="notice-pop-up-content-body">
                            <span dangerouslySetInnerHTML={{__html:item.context.body}}></span>
                            <span>{window.moment(item.context.date).calendar()}</span>
                        </div>
                    </div>
                    {isAddingPlayer &&
                        <AddPlayer sport={item.actionData.contextTarget.sport.name.toLowerCase()} isOpen={isAddingPlayer} teamId={item.actionData.contextTarget.id} squadId={item.actionData.contextTarget.squadId} gender={item.actionData.contextTarget.gender} name={item.actionData.contextTarget.name} onClose={(player) => {
                            if (player === null) {
                                this.setState({ isAddingPlayer: false })
                                return;
                            } else {
                                this.setState({ isAddingPlayer: false })
                                activeAction.action(player)
                                return;
                            }
                        }} onPlayerSave={this.onPlayerSave.bind(this)} />
                    }
                    <div className="notice-pop-up-actions">
                        {
                            FakeData.listify(actions).map((_item, i) => {
                                if (!_item.jsx) {
                                    return (
                                        <_item.link key={"action_" + i} />
                                    )
                                } else {
                                    if (item.actionData.context === "team_invite") {
                                        return (
                                            <_item.jsx key={"action_" + i} onClick={(e) => {
                                                this.acceptTeamInvite(e, _item)
                                            }} />
                                        )
                                    }
                                    return (
                                        <_item.jsx key={"action_" + i} onClick={_item.action} />
                                    )
                                }
                            })
                        }
                    </div>
                </div>
            </Modal>
        )
    }
}

export class AddPlayer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            image: { id: null, url: "" },
            token: "new",
            player: {
                name: "",
                email: "",
                position: "",
                origin: "",
                number: "",
                image: "",
                gender: "",
                height: "",
                age: "",
                games: 0,
                goals: 0
            },
            error: {
                user: false,
                name: false,
                position: false,
                number: false,
                origin: false,
                email: false,
                gender: false
            },
            user: { id: null, name: "" },
            isSearching: false,
            players: []
        }
    }

    componentDidMount = () => {
        this.getSquadPlayers()
    }

    save() {
        const { player, isSearching, user, error } = this.state

        if (player.position === "" || error.position) {
            error.position = true;
            this.setState({ error });
            return;
        }

        if (player.number === "" || error.number) {
            error.number = true;
            this.setState({ error });
            return;
        }

        if (player.origin === "" || error.origin) {
            error.origin = true;
            this.setState({ error });
            return;
        }

        this.props.onPlayerSave(player)
    }

    getJerseys = () => {
        const list = [];
        const { players } = this.state;
        FakeData.listify(players).forEach((item, i) => {
            if (!FakeData.inArray(item.number, list)) {
                list.push(item.number)
            }
        })

        return list
    }

    getSquadPlayers = () => {
        const _that = this
        const dataTo = {
            teamId: this.props.teamId,
            squadId: this.props.squadId
        }

        FakeData.post("/getSquadPlayers.php?auth0", dataTo, {
            success(res) {
                console.log(res)
                _that.setState({ players: res });
            },
            error(err) {

            }
        }, true, "", (s) => { })
    }

    render() {
        const { player, isSearching, user, error, token } = this.state
        const positions = Positions[this.props.sport];
        const { gender } = this.props
        const genderRequired = (gender === "mixed") ? true : false;
        const jerseyArray = this.getJerseys()
        return (
            <Modal isOpen={this.props.isOpen} onClose={() => this.props.onClose(null)}>
                <div className="add-place" style={{ width: "400px" }}>
                    <h1>Add player to {this.props.name} squad</h1>
                    <h4 style={{ cursor: "pointer", color: (!isSearching) ? "#aaa" : "#CCC", paddingBottom: "5px", borderBottom: "none", position: "relative" }}>
                        Add New Player
                            <i className="material-icons" style={{ fontSize: "14px", position: "absolute", right: 0, marginTop: "10px", marginRight: "10px" }}>{(!isSearching) ? "add" : "remove"}</i>
                    </h4>
                    <div style={{ width: "100%" }}>
                        <div className="input-field">
                            <span>Position</span>
                            <select className={(error.position) ? "normal-input error" : "normal-input"} style={{ border: "0.3px solid #aaa!important" }}
                                value={player.position}
                                onChange={(e) => {
                                    player.position = e.target.value;
                                    error.position = false
                                    this.setState({ player, error });
                                }} >
                                <option value="">Select position</option>
                                {
                                    FakeData.listify(positions).map((item, i) => {
                                        return (<option key={i} value={item}>{item}</option>)
                                    })
                                }
                            </select>
                        </div>
                        <div className="input-field">
                            <span>Jersey</span>
                            <input className={(error.number) ? "normal-input error" : "normal-input"} style={{ border: "0.3px solid #aaa!important" }}
                                value={player.number}
                                type="number"
                                min={1}
                                max={200}
                                onChange={(e) => {
                                    player.number = e.target.value;
                                    error.number = FakeData.inArray(e.target.value, jerseyArray)
                                    this.setState({ player, error });
                                }} />
                        </div>
                        <div className="input-field">
                            <span>County</span>
                            <CountryDropdown classes={(error.origin) ? "normal-input error" : "normal-input"}
                                value={player.origin}
                                onChange={(val) => {
                                    player.origin = val;
                                    error.origin = false
                                    this.setState({ player, error });
                                }} />
                        </div>
                        <button style={{ lineHeight: "30px" }} onClick={this.save.bind(this)}>Accept Invite</button>
                    </div>
                </div>
            </Modal>
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/InternalNoticeCenter.jsx